<div class="container">
  <div class="content">
    <app-stepper-header
      title="SRE Report"
      i18n-title="@@sre.reportTitle"
      [steps]="steps"
      [step]="step">
    </app-stepper-header>

    <div class="panel-container">
      <div class="step-container">
        <div *ngIf="step === 0" style="max-width: 640px">
          <app-item-form
            [formGroup]="itemForm"
            reportType="SRE"
            (classificationSelect)="onClassificationSelect($event)">
          </app-item-form>

          <app-sre-photo-grid
            [photos]="photos"
            [required]="true"
            [showError]="photoError"
            (photosChange)="onPhotosChange($event)">
          </app-sre-photo-grid>
        </div>

        <app-sre-details-form *ngIf="step === 1" [formGroup]="detailsForm"></app-sre-details-form>
      </div>

      <div *ngIf="submitFailed" class="submit-error" style="color: red; margin-bottom: 1rem">
        <ng-container i18n="@@sre.submitFailed">The report could not be saved. Please try again.</ng-container>
      </div>

      <div class="stepper-actions">
        <button
          pButton
          label="Cancel"
          i18n-label="@@cancelButton"
          class="p-button-text"
          type="button"
          (click)="goBack()">
        </button>

        <button
          *ngIf="step === 1"
          pButton
          label="Back"
          i18n-label="@@sre.backButton"
          class="p-button-text"
          type="button"
          (click)="prevStep()">
        </button>

        <button
          *ngIf="step === 0"
          pButton
          label="Next"
          i18n-label="@@nextButton"
          class="p-button-primary"
          type="button"
          (click)="nextStep()">
        </button>

        <button
          *ngIf="step === 1"
          pButton
          label="Create"
          i18n-label="@@createButton"
          class="p-button-primary"
          type="button"
          (click)="submit()"
          [loading]="isSubmitting">
        </button>
      </div>
    </div>
  </div>
</div>
